import React, {
  useEffect,
  useRef,
  useState,
} from 'react'
import Loader from 'react-loader-spinner'
import { connect } from 'react-redux'
import {
  clearStatusOfDMS,
  getStatusOfDMS,
  updateJobStatus,
} from '../../store/actions'

import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'
import './index.css'

const StatusModal = props => {
  const [ status, setStatus ] = useState('pending')
  const [ isLoading, setIsLoading ] = useState(false)
  const intervalStatusDMS = useRef()


  useEffect(() => {
    if (!props.status) {

      return
    }
    if (intervalStatusDMS.current) {
      clearInterval(intervalStatusDMS.current)
    }
    intervalStatusDMS.current = setInterval(() => {
      props.getStatusOfDMS(props.id)
    }, 1000 * 60)
  }, [ props.status ])

  useEffect(() => {
    if (!props.status) {
      return
    }
    setIsLoading(true)

    if (props.status !== 'pending') {
      clearInterval(intervalStatusDMS.current)
      setStatus(props.status)
      if (props.status === 'completed') {
        props.updateJobStatus(props.id, 'completed')
      }
    }
  }, [ props.status ])

  const handleClick = async () => {
    await props.getStatusOfDMS(props.id)
  }

  const handleClickClose = async () => {
    props.clearStatusOfDMS()
    props.setIsStatusModalOpen(false)
  }

  const body = (
    <div className="info-modal__filter">
      <h2 className="info-modal__title">Completed Job</h2>
      <div>
        <h4>Job Status {status}</h4>
        {props.status === 'pending' ?
          <Loader className='status-loading__bar'
                  type="ThreeDots"
                  color="#00BFFF"
                  height={400}
                  width={40}
          /> : null}


      </div>
    </div>
  )
  const footer = (
    <div className="variance-list-modal__form-group variance-list-modal__controls variance-list-modal__footer">
      {status === 'pending' ? <ButtonPrimary onClick={() => handleClick()} name="Check Status" />
        :
        <ButtonPrimary onClick={() => handleClickClose()} name="Close" />
      }

    </div>
  )
  return (
    <BaseModal
      onClose={handleClickClose}
      body={body}
      footer={footer}
    />
  )
}
const mapStateToProps = ({ data: { status } }) => ({ status })
const mapDispatchToProps = ({ getStatusOfDMS, clearStatusOfDMS, updateJobStatus })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StatusModal)




